<template>
    <div class="card mb-1">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Dental Service"
            />
        </div>
        <div class="row p-1">
            <StatisticsCard
                v-for="statistic in statistics"
                :key="statistic.title"
                :icon="statistic.icon"
                :title="statistic.title"
                :count="statistic.count"
                :bgColor="statistic.bgColor"
                :id="statistic.id"
            />
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import StatisticsCard from '@/components/molecule/company/dental-os/single-service/components/StatisticsCard.vue';
import { ref } from 'vue';

const props = defineProps({
    stats: {
        type: [Object, null],
        default: null
    }
})

const statistics = ref([
    {
        id: 'today_treatment_count',
        icon: '/app-assets/images/icons/prescription/td_schedule.png',
        title: 'Today\'s Schedule',
        count: props.stats ? props.stats.today_treatment_count : 0,
        bgColor: '#00cfe81f'
    },
    {
        id: 'tomorrow_treatment_count',
        icon: '/app-assets/images/icons/prescription/tm_schedule.png',
        title: 'Tomorrow\'s Schedule',
        count: props.stats ? props.stats.tomorrow_treatment_count : 0,
        bgColor: '#28c76f1f'
    },
    {
        id: 'today_collection',
        icon: '/app-assets/images/icons/prescription/collection.png',
        title: 'Today\'s Collection',
        count: props.stats ? props.stats.today_collection : 0,
        bgColor: '#fceaea'
    },
    {
        id: 'total_receivables',
        icon: '/app-assets/images/icons/prescription/due.png',
        title: 'Due Bill',
        count: props.stats ? props.stats.total_receivables : 0,
        bgColor: '#eeedfd'
    }
]);

</script>

<style scoped>
</style>
